import { EmployeeItem } from "@/components/employee/EmployeeItem.tsx";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { Stack } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

export interface Props {
  employee?: ApiEmployee | null;
  text: string;
  isShort?: boolean;
}
export const Comment = ({ employee, text, isShort = true }: Props) => {
  return (
    <Stack className={"bg-dark/5 p-4 rounded-xs border border-brand-dark/5"} gap={"sm"}>
      {employee && (
        <EmployeeItem employee={employee} variant={"secondary"} size={"sm"} showPosition={false} />
      )}
      <span
        className={twMerge(
          "text-secondary",
          isShort ? "text-ellipsis overflow-hidden line-clamp-3" : "whitespace-pre-wrap"
        )}
      >
        {text}
      </span>
    </Stack>
  );
};
